export const OpsgenieLogoBrand = () => (
    <svg
        width="231"
        height="48"
        viewBox="0 0 231 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M15.694 25.5421C20.8441 25.5421 25.019 21.3671 25.019 16.2171C25.019 11.067 20.8441 6.89209 15.694 6.89209C10.544 6.89209 6.36902 11.067 6.36902 16.2171C6.36902 21.3671 10.544 25.5421 15.694 25.5421Z"
            fill="url(#paint0_linear_818_564)"
        />
        <path
            d="M14.899 44.037C8.80899 40.152 3.74399 34.857 0.13199 28.601C-0.14901 28.097 0.0319899 27.46 0.53699 27.179C0.55299 27.17 0.56999 27.161 0.58699 27.153L7.64899 23.687C8.14299 23.446 8.73899 23.629 9.01299 24.105C12.583 30.089 17.863 34.868 24.172 37.827C21.845 40.171 19.268 42.254 16.488 44.037C16.002 44.341 15.385 44.341 14.899 44.037Z"
            fill="url(#paint1_linear_818_564)"
        />
        <path
            d="M16.488 44.037C22.579 40.153 27.644 34.858 31.255 28.601C31.537 28.097 31.357 27.46 30.853 27.178C30.837 27.169 30.821 27.161 30.805 27.153L23.738 23.687C23.244 23.446 22.648 23.629 22.374 24.105C18.804 30.09 13.525 34.869 7.21497 37.827C9.53997 40.173 12.117 42.256 14.899 44.037C15.385 44.341 16.002 44.341 16.488 44.037Z"
            fill="#1D7AFC"
        />
        <path
            d="M44.033 23.5709C44.033 14.4619 49.278 8.06689 58.617 8.06689C67.956 8.06689 73.155 14.4619 73.155 23.5709C73.155 32.7719 67.91 39.2129 58.617 39.2129C49.324 39.2129 44.033 32.7729 44.033 23.5709ZM48.174 23.5709C48.174 29.9659 51.164 35.2559 58.617 35.2559C66.024 35.2559 69.014 29.9659 69.014 23.5709C69.014 17.3139 66.024 12.0229 58.617 12.0229C51.164 12.0229 48.174 17.3139 48.174 23.5709Z"
            fill="#172B4D"
        />
        <path
            d="M82.3979 34.704V47.724H78.4409V15.75H82.3979V19.891C83.8699 16.855 86.6299 15.29 90.1719 15.29C96.2909 15.29 99.3729 20.488 99.3729 27.251C99.3729 33.738 96.1519 39.213 89.7119 39.213C86.3539 39.213 83.7769 37.694 82.3979 34.704ZM89.1139 18.971C85.5719 18.971 82.3979 21.225 82.3979 26.331V28.172C82.3979 33.278 85.2949 35.532 88.6539 35.532C93.1169 35.532 95.4169 32.588 95.4169 27.251C95.4169 21.73 93.2089 18.971 89.1139 18.971Z"
            fill="#172B4D"
        />
        <path
            d="M111.193 39.213C107.743 39.213 104.936 38.431 103.188 37.511V33.324C105.167 34.474 108.479 35.578 111.377 35.578C114.413 35.578 115.978 34.336 115.978 32.542C115.978 30.794 114.643 29.781 110.273 28.724C105.167 27.482 103.004 25.503 103.004 21.731C103.004 17.729 106.086 15.291 111.331 15.291C114.321 15.291 117.035 16.027 118.737 16.947V21.042C115.977 19.661 113.722 18.926 111.284 18.926C108.387 18.926 106.822 19.938 106.822 21.732C106.822 23.342 107.926 24.355 112.159 25.367C117.265 26.609 119.842 28.495 119.842 32.498C119.842 36.316 117.358 39.215 111.193 39.215V39.213Z"
            fill="#172B4D"
        />
        <path
            d="M140.818 34.612C139.345 37.648 136.586 39.213 133.043 39.213C126.971 39.213 123.935 34.014 123.935 27.251C123.935 20.765 127.109 15.29 133.504 15.29C136.862 15.29 139.439 16.809 140.818 19.799V15.75H144.682V36.683C144.682 43.446 141.508 48 133.273 48C129.409 48 127.293 47.494 125.085 46.758V42.894C127.615 43.722 130.237 44.274 133.09 44.274C138.84 44.274 140.819 41.192 140.819 36.913V34.613L140.818 34.612ZM134.101 35.532C137.643 35.532 140.818 33.278 140.818 28.172V26.331C140.818 21.225 137.92 18.971 134.561 18.971C130.098 18.971 127.798 21.915 127.798 27.251C127.798 32.772 130.006 35.532 134.101 35.532Z"
            fill="#172B4D"
        />
        <path
            d="M161.655 39.213C153.052 39.213 149.28 34.244 149.28 27.205C149.28 20.259 153.144 15.29 160.137 15.29C167.221 15.29 170.074 20.213 170.074 27.205V29H153.282C153.835 32.91 156.365 35.44 161.794 35.44C164.462 35.44 166.716 34.934 168.786 34.198V37.833C166.9 38.845 164.002 39.213 161.655 39.213ZM153.236 25.595H166.072C165.842 21.317 163.91 18.879 159.953 18.879C155.766 18.879 153.65 21.593 153.236 25.595Z"
            fill="#172B4D"
        />
        <path
            d="M194.316 38.753H190.359V24.859C190.359 20.718 188.703 18.879 184.93 18.879C181.25 18.879 178.72 21.317 178.72 25.963V38.753H174.763V15.75H178.72V19.522C180.192 16.808 182.906 15.29 185.989 15.29C191.279 15.29 194.316 18.925 194.316 25.273V38.752V38.753Z"
            fill="#172B4D"
        />
        <path
            d="M201.858 6.91699C203.468 6.91699 204.618 7.92899 204.618 9.67799C204.618 11.427 203.469 12.438 201.858 12.438C200.247 12.438 199.097 11.426 199.097 9.67799C199.097 7.92999 200.247 6.91699 201.858 6.91699ZM199.834 15.75H203.791V38.753H199.834V15.75Z"
            fill="#172B4D"
        />
        <path
            d="M221.685 39.213C213.082 39.213 209.31 34.244 209.31 27.205C209.31 20.259 213.174 15.29 220.167 15.29C227.251 15.29 230.104 20.213 230.104 27.205V29H213.312C213.865 32.91 216.395 35.44 221.824 35.44C224.492 35.44 226.746 34.934 228.816 34.198V37.833C226.93 38.845 224.032 39.213 221.685 39.213ZM213.266 25.595H226.102C225.872 21.317 223.94 18.879 219.983 18.879C215.796 18.879 213.68 21.593 213.266 25.595Z"
            fill="#172B4D"
        />
        <defs>
            <linearGradient
                id="paint0_linear_818_564"
                x1="15.694"
                y1="9.99209"
                x2="15.694"
                y2="29.1391"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#1D7AFC" />
                <stop offset="0.82" stopColor="#0055CC" />
            </linearGradient>
            <linearGradient
                id="paint1_linear_818_564"
                x1="9.94799"
                y1="28.603"
                x2="16.362"
                y2="42.027"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#1D7AFC" />
                <stop offset="0.62" stopColor="#0055CC" />
            </linearGradient>
        </defs>
    </svg>
);
